import { SuccessIcon } from 'assests/GmsIcons';
import React from 'react';


const ResultPage = ({ attributes }: { attributes: TOption[] }) => {

    const backendTasks = [
        "Deleting products from the Source Category CBM rule",
        "Rerunning CBA, CBI and CBM rules",
        "Refreshing the Configurator",
        "Refreshing Smart Builder 2",
        "Refreshing the Product Cache"
    ];
    

    return (
        <div className="tw-max-w-3xl tw-mx-auto tw-p-8">
            <div className="tw-flex tw-justify-center tw-items-center tw-text-center tw-gap-3 tw-mb-8">
                <div className="tw-bg-tone-success-tint tw-rounded-full tw-p-1">
                    <SuccessIcon />
                </div>
                <h1 className="tw-text-sm tw-text-ink">
                    Recategorization Successful
                </h1>
            </div>
    
            <div className="tw-mb-8">
                    <h2 className="tw-text-sm tw-text-ink tw-mb-4">
                    Backend re-computation in progress:
                    </h2>
                    <ul className="tw-space-y-2 tw-ms-2">
                        {backendTasks.map((task, index) => (
                            <li key={index} className="tw-text-ink tw-font-semibold tw-text-sm">
                            • {task}
                            </li>
                        ))}
                    </ul>
            </div>

            <div className="tw-w-2x tw-h-[0px] tw-border tw-border-edge tw-my-3" />
    
            <div className="tw-mb-8">
                <div className="tw-flex tw-justify-between tw-items-center tw-mb-4">
                    <h2 className="tw-text-sm tw-text-ink">
                        Perform the below actions -
                    </h2>
                </div>
    
                <div className="tw-flex tw-items-center">
                    <h3 className="tw-text-ink tw-font-semibold tw-text-sm tw-w-32 tw-h-full tw-flex tw-items-center">Category</h3>
                    <div className="tw-flex-1 tw-bg-surface-sunken tw-rounded tw-p-3">
                        <div className="tw-mb-4">
                            <p className="tw-text-ink tw-text-sm">Attribute Values Update Required -</p>
                        </div>
                        <div className='tw-h-auto  tw-w-auto tw-overflow-y-auto tw-mb-2'>
                            {attributes?.map((attribute, index) =>
                                <div key={index} className="tw-h-5 tw-m-1 tw-px-[5px] tw-bg-tone-neutral-tint tw-rounded-sm tw-inline-flex tw-justify-center tw-items-center tw-gap-2.5">
                                    <span className="tw-text-ink tw-text-xs tw-font-normal tw-font-['Noto Sans'] tw-leading-tight">
                                        {attribute?.name}
                                    </span>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ResultPage;